import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6aa08b632253d30014ae8867_1789539439943_b5e1f60b/x39pitch/src/components/pitch/PitchDeck.tsx");
